module.exports = __webpack_public_path__ + "img/logo_latest.fb58a9ad.svg";